import React from "react";
import { AgendamientoResumido } from "../../services/agendamientosServicios";
import { isAgendamientoGuarderiaResumido } from "../../services/agendamientosGuarderiaServicios";
import { AgendamientoResumidoGuarderia } from "./AgendamientoResumidoGuarderia";
import { AgendamientoResumidoHotel } from "./AgendamientoResumidoHotel";
import { AgendamientoResumidoSpa } from "./AgendamientoResumidoSpa";
import { isAgendamientoHotelResumido } from "../../services/agendamientosHotelServicios";
import { isAgendamientoSpaResumido } from "../../services/agendamientosSpaServicios";

export const ResumenAgendamiento = ({
  agendamientoResumido,
}: {
  agendamientoResumido: AgendamientoResumido;
}) => {
  if (isAgendamientoGuarderiaResumido(agendamientoResumido)) {
    return (
      <AgendamientoResumidoGuarderia agendamiento={agendamientoResumido} />
    );
  }
  if (isAgendamientoHotelResumido(agendamientoResumido)) {
    return <AgendamientoResumidoHotel agendamiento={agendamientoResumido} />;
  }
  if (isAgendamientoSpaResumido(agendamientoResumido)) {
    return <AgendamientoResumidoSpa agendamiento={agendamientoResumido} />;
  }
  return <></>;
};
